import axios from 'axios'
import { passThroughAxios } from './passThrough.axios'

export default {
  async getStockcarsNew(params) {
    try {
      const response = await axios.get('GetStockCarsNew', { params })
      return response.data
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },

  async getSyntecReservationNew(commissionNumber) {
    try {
      const response = await passThroughAxios.get('stockcarsNew/syntec/reservation', {
        params: { commissionNumber },
      })
      return response.data
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },

  async getStockCarQuotes(commissionNumber, commissionYear) {
    try {
      const response = await passThroughAxios.get('stockcarsNew/quotes', {
        params: { commissionNumber, commissionYear },
      })
      return response.data
    } catch (e) {
      if (e.response?.status === 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
}
